export enum TransmissionType {
    Automatic = 1, Manual
}